export const FORGE_FIELD_TYPE_PREFIX = 'ari:cloud:ecosystem::extension/';
export const PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX = 'com.atlassian.forge:';
export const LEGACY_FORGE_FIELD_TYPE_PREFIX = `${PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX}${FORGE_FIELD_TYPE_PREFIX}`;

export const isForgeLegacyFieldType = (fieldType: string): boolean =>
	fieldType.startsWith(LEGACY_FORGE_FIELD_TYPE_PREFIX);

export const getExtensionIdFromLegacyFieldType = (fieldType: string): string | null =>
	fieldType.split(PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX)[1] || null;
